import { BadgeCheck } from "lucide-react";

/**
 * Single source of truth for the public "verified review" badge.
 * Always renders: Verified review · ORDER ID: TW••••42
 * The order ref is already masked server-side (see src/lib/reviews/mask.ts).
 */
export function VerifiedPurchaseBadge({
  orderRef,
  className = "",
}: {
  orderRef?: string | null;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-[#1E5EFF]/10 px-2 py-0.5 text-[11px] font-medium normal-case tracking-normal text-[#1E5EFF] ${className}`}
    >
      <BadgeCheck size={13} strokeWidth={2.5} /> Verified review
      {orderRef && (
        <span className="font-normal text-[#1E5EFF]/70">· ORDER ID: {orderRef}</span>
      )}
    </span>
  );
}
